import { useGetHasScope } from 'crm-object-board-core/user';
export function useIsSuperAdmin() {
  const {
    hasScope,
    loading: scopesLoading
  } = useGetHasScope();
  if (scopesLoading) {
    return false;
  }
  return hasScope('properties-settings-write');
}